import httpClient from './http-client';
import { store } from '../store/store';

export const STATUS_OPTIONS = [
  { key: "Planned", labelKey: "Planned" },
  { key: "In Preparation", labelKey: "In Preparation" },
  { key: "In Progress", labelKey: "In Progress" },
  { key: "Completed", labelKey: "Completed" },
  { key: "Cancelled", labelKey: "Cancelled" },
];

export default class TurnAroundService {
    private baseApiEndpoint = '/api/tas';
    private idToken: string | undefined = '';
    private accessToken: string | undefined = '';

    constructor(idToken?: string | undefined, accessToken?: string | undefined) {
        this.idToken = idToken;
        this.accessToken = accessToken;
        this.baseApiEndpoint = import.meta.env.VITE_BYPASS_PROXY === 'true' 
                                ? '' : this.baseApiEndpoint;
    }

    private getUserGuid(): string {
        const user = store.getState().user.data;
        return user?.id || '';
    }

    private getSelectedSiteId(): string {
        const selection = store.getState().selection;
        return selection.selectedSiteId || '';
    }

    async getTurnarounds(): Promise<any> {
        const userGuid = this.getUserGuid();
        const siteId = this.getSelectedSiteId();
        let response
        try {
            response = await httpClient.get(
                `${this.baseApiEndpoint}/turnarounds?user_guid=${userGuid}&site_id=${siteId}&requestId=${new Date().getTime().toString()}`
            );
        } catch (error) {
            console.error('Error fetching turnarounds:', error);
            throw error;
        }
        
        return response?.data || null;
    }

    async getTurnaroundById(turnaroundId: string): Promise<any> {
        const userGuid = this.getUserGuid();
        let response
        try {
            response = await httpClient.get(
                `${this.baseApiEndpoint}/turnarounds/${turnaroundId}?user_guid=${userGuid}`
            );
        } catch (error) {
            console.error('Error fetching turnaround details:', error);
            throw error;
        }
        
        return response?.data || null;
    }

    async createTurnaround(data: any): Promise<any> {
        const userGuid = this.getUserGuid();
        let response
        try {
            response = await httpClient.post(
                `${this.baseApiEndpoint}/turnarounds?user_guid=${userGuid}`,
                data
            );
        } catch (error) {
            console.error('Error creating turnaround:', error);
            throw error;
        }
        
        return response?.data || null;
    }

    async updateTurnaround(turnaroundId: string, data: any): Promise<any> {
        const userGuid = this.getUserGuid();
        let response
        try {
            response = await httpClient.post(
                `${this.baseApiEndpoint}/turnarounds/${turnaroundId}?user_guid=${userGuid}`,
                data
            );
        } catch (error) {
            console.error('Error updating turnaround:', error);
            throw error;
        }
        
        return response?.data || null;
    }

    async deleteTurnaround(turnaroundId: string): Promise<any> {
        const userGuid = this.getUserGuid();
        let response
        try {
            response = await httpClient.delete(
                `${this.baseApiEndpoint}/turnarounds/${turnaroundId}?user_guid=${userGuid}`
            );
        } catch (error) {
            console.error('Error deleting turnaround:', error);
            throw error;
        }
        
        return response?.data || null;
    }

    async addDevicesToTurnaround(turnaroundId: string, deviceIds: string[]): Promise<any> {
        const userGuid = this.getUserGuid();
        let response
        try {
            response = await httpClient.post(
                `${this.baseApiEndpoint}/turnarounds/${turnaroundId}/devices?user_guid=${userGuid}`,
                { devices: deviceIds }
            );
        } catch (error) {
            console.error('Error adding devices to turnaround:', error);
            throw error;
        }
        
        return response?.data || null;
    }

    async deleteDevicesFromTurnaround(turnaroundId: string, deviceIds: string[]): Promise<any> {
        const userGuid = this.getUserGuid();
        let response
        try {
            response = await httpClient.delete(
                `${this.baseApiEndpoint}/turnarounds/${turnaroundId}/devices?user_guid=${userGuid}`,
                {
                    data: {
                        devices: deviceIds
                    }
                }
            );
        } catch (error) {
            console.error('Error deleting devices from turnaround:', error);
            throw error;
        }
        
        return response?.data || null;
    }
}
